import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourConsentsConfigPage from '@/features/dashboard/tourConsents/pages/TourConsentsConfigPage.tsx';

export const tourConsentsConfigRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'consents',
  component: TourConsentsConfigPage,
});
